export default __webpack_public_path__ + "images/5f1b8bb9ce0caaf747f93b16c0a36e2f.svg";